export default __webpack_public_path__ + "static/media/CO_intro_video.0428953e.mp4";